<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      app-pdf-viewer-old(
        v-if="isEstadoAP"
        :bytes="bytes"
      )
      app-pdf-viewer(
        v-else
        :bytes="bytes"
      )
    template(slot="footer")
      div.flex
        el-button(@click="downloadPdf")
          i.fal.fa-file-pdf
          span &nbsp Exportar PDF
</template>

<script>
import AppModal from '@/components/AppModal'
import AppPdfViewer from '@/components/AppPDFViewer'
import AppPdfViewerOld from '@/components/AppPDFViewerOld'
import FileHelper from '@/utils/fileHelper'

export default {
  components: {
    AppModal,
    FileHelper,
    AppPdfViewer,
    AppPdfViewerOld
  },

  props: {
    titulo: { required: true, type: String },
    width: { default: window.innerWidth * 0.85, type: Number },
    bytes: { required: true, type: ArrayBuffer }
  },
  computed: {
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    }
  },
  methods: {
    downloadPdf () {
      FileHelper.saveFile(this.bytes, 'titulo')
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  display: flex;
  justify-content: flex-end;
}

.w-70 {
  width: 70%;
}

.margin-bottom {
  margin-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalVisualizarTitulo.vue